export const FOLDER_NAME = 'ResyValue';
export const FILE_NAME = 'ResyValueData.json';
